"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DESCRIPTION_MAX_LEN = exports.NAME_MAX_LEN = void 0;
exports.NAME_MAX_LEN = 40;
exports.DESCRIPTION_MAX_LEN = 60;
//# sourceMappingURL=consts.js.map